export default (ngModule: ng.IModule) => {

  ngModule
    .directive('errSrc', function errSrc(): ng.IDirective {
      return {
        restrict: 'A',
        link: link
      };

      function link(scope, elem) {
        elem.bind('error', () => elem.css('display', 'none'));
      }
    });
};




/** WEBPACK FOOTER **
 ** ../~/tslint-loader!./common/decorators/err-src.directive.ts
 **/